import { State } from 'App/state/rootState';

export const colorThemeSelector = (state: State) => state.colorTheme;
